import { motion } from "framer-motion";
import { useState } from "react";
import styles from "./home_3.module.css";
import img1 from "../../assets/images/home_3/Asset 22@2x.png";
import img2 from "../../assets/images/home_3/Asset 23@2x.png";
import img3 from "../../assets/images/home_3/Asset 24@2x.png";
import img4 from "../../assets/images/home_3/Asset 29@2x.png";
import img5 from "../../assets/images/home_3/Asset 25@2x.png";
import img6 from "../../assets/images/home_3/Asset 38@2x.png";
import divider from "../../assets/images/divider.png";
import DanM_6_11 from "../../assets/images/product/DanM_6-11kg.png";
import DanNB_5 from "../../assets/images/product/DanNB-duoi5kg.png";
import DanS_3_8 from "../../assets/images/product/DanS_3-8kg.png";
import QuanL_9_14 from "../../assets/images/product/QuanL9-14kg.png";
import QuanM_6_11 from "../../assets/images/product/QuanM_6-11kg.png";
import QuanXL_12_17 from "../../assets/images/product/QuanXL_12-17kg.png";
import QuanXXL_15 from "../../assets/images/product/QuanXXL_15kg.png";
import { useTranslation } from "../../context/LanguageContext";
function Home3() {
  const { translate, locale } = useTranslation();

  const listTypes = [
    { id: 0, label: translate("all") },
    {
      id: 1,
      label: translate("t1"),
    },
    {
      id: 2,
      label: translate("t2"),
    },
  ];
  const listWeights = [
    { id: 1, label: translate("w1") },
    { id: 2, label: translate("w2") },
    { id: 3, label: translate("w3") },
    { id: 4, label: translate("w4") },
    { id: 5, label: translate("w5") },
    { id: 6, label: translate("w6") },
  ];

  const [productType, setProductType] = useState(0);
  const [productWeight, setProductWeight] = useState(listWeights[0].id);
  // lọc ra product có trung với  productType và productWeight nào nếu có productType hoặc productWeight
  const productTypeFilter = [
    {
      id: 2,
      name: "p2",
      image: DanNB_5,
      weight: { id: 1 },
      type: { id: 2 },
    },

    {
      id: 3,
      name: "p3",
      image: DanS_3_8,
      weight: { id: 2 },
      type: { id: 2 },
    },
    {
      id: 1,
      name: "p1",
      image: DanM_6_11,
      weight: { id: 3 },
      type: { id: 2 },
    },
    {
      id: 5,
      name: "p5",
      image: QuanM_6_11,
      weight: { id: 3 },
      type: { id: 1 },
    },
    {
      id: 4,
      name: "p4",
      image: QuanL_9_14,
      weight: { id: 4 },
      type: { id: 1 },
    },
    {
      id: 6,
      name: "p6",
      image: QuanXL_12_17,
      weight: { id: 5 },
      type: { id: 1 },
    },
    {
      id: 7,
      name: "p7",
      image: QuanXXL_15,
      weight: { id: 6 },
      type: { id: 1 },
    },
  ].filter((product) => {
    // nếu có cả 2 thì phải lọc ra product có trung với  productType và productWeight
    //  nếu có productType hoặc productWeight thì phải lọc ra product có trung với  productType hoặc productWeight
    // nếu không có cả 2 thì không lọc
    if (productType === -1 && productWeight) {
      return product?.weight?.id === productWeight;
    } else if (productType && productWeight) {
      return (
        product?.weight?.id === productWeight &&
        product?.type?.id === productType
      );
    }

    return product;
  });
  return (
    <section className={`bg-[#fffaf3] pb-12 pt-[86px] relative ${styles.main}`}>
      <div className="max-w-[1500px] mx-auto w-full">
        <motion.div
          className="absolute top-[52px] left-[303px]"
          initial={{ opacity: 0, scale: 0.5 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <img src={img1} alt="img" width={256} height={162} />
        </motion.div>
        <motion.div
          className="absolute top-[394px] left-[363px]"
          initial={{ opacity: 0, scale: 0.5 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <img src={img2} alt="img" width={110} height={130} />
        </motion.div>
        <motion.div
          className="absolute top-[78px] right-[173px]"
          initial={{ opacity: 0, scale: 0.5 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <img src={img3} alt="img" width={285} height={222} />
        </motion.div>
        <motion.div
          className="absolute top-[513px] right-[390px]"
          initial={{ opacity: 0, scale: 0.5 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <img src={img4} alt="img" width={89} height={85} />
        </motion.div>
        <div id="product" className="pt-4">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <img
              className="mx-auto"
              src={img5}
              alt="img"
              width={768}
              height={472}
            />
          </motion.div>
        </div>
        <div className="mt-[54px] mb-[72px]">
          <motion.h2
            initial={{ opacity: 0, y: -40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center text-[98px] leading-[1] font-semibold text-black mt-10 mb-0.5"
          >
            {translate("product")}
          </motion.h2>
        </div>
        <div className="flex flex-row gap-16">
          <div className="w-[360px] pt-3 ">
            <div className="mb-[80px]">
              <Label label={translate("type")} />
              <List
                type="type"
                list={listTypes}
                setValue={setProductType}
                value={productType}
              />
            </div>
            <div>
              <Label label={translate("weight")} />
              <List
                type="weight"
                list={listWeights}
                setValue={setProductWeight}
                value={productWeight}
              />
            </div>
          </div>
          <div className="flex-1 ">
            <div className="grid grid-cols-3 grid-rows-none gap-5">
              {productTypeFilter?.map((product) => (
                <div
                  key={product?.id}
                  className="bg-[#fff8f0] rounded-[46px] px-5 pt-8 pb-7"
                >
                  <div className="px-7">
                    <img
                      className="mx-auto "
                      src={product?.image}
                      alt="img"
                      width={239}
                      height={312}
                      style={{
                        aspectRatio: 239 / 312,
                        width: "100%",
                        height: "auto",
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                    />
                  </div>
                  <div className="w-full pt-2 pb-4">
                    <img
                      className="mx-auto"
                      src={divider}
                      alt="img"
                      width={292}
                      height={1}
                    />
                  </div>
                  <div className="font-bricolage px-5">
                    <h4 className="text-[25px] leading-[1.2] text-black font-semibold ">
                      {translate(product?.name)}
                    </h4>

                    <p className="text-[32px] leading-[1.2] text-black font-semibold">
                      {locale === "kr" ? "10.500" : "235.000"}
                      <sup className="text-[20px]">
                        {locale === "kr" ? "₩" : "đ"}
                      </sup>
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Home3;
const Label = ({ label }) => {
  return (
    <div className="relative mb-[40px]">
      <img src={img6} alt="img" width={360} height={132} />
      <h4 className="text-[54px] leading-[1.2] text-white text-center font-semibold absolute top-0 left-0 py-6 w-full">
        {label}
      </h4>
    </div>
  );
};

const List = ({ type, list, setValue, value }) => {
  return (
    <ul className="flex flex-col gap-6 pl-[70px]">
      {list?.map((item) => (
        <li key={type + item?.id} className="flex">
          <span
            className={`inline-block cursor-pointer size-[22px] mt-1.5 mr-6 bg-[#C5BAD8] rounded-full transition-all duration-300 border-2 border-[#C5BAD8] ${
              value === item?.id ? "bg-[#fff]" : ""
            }`}
            onClick={() => setValue(item?.id)}
          ></span>
          <span className="font-bricolage text-[33px] font-semibold">
            {item.label}
          </span>
        </li>
      ))}
    </ul>
  );
};
